import type { FC } from "react";
import type { ISubsetOfUsersText, INotification } from "app/components/sharingAssetModal/types";
import { ESharingState } from "app/components/sharingAssetModal/types";
import { SharingOption } from "app/components/sharingAssetModal/components/sharingStateRadioOptions/SharingOption";
import styled from "styled-components";
import { NotificationManager } from "app/components/sharingAssetModal/components/sharingStateRadioOptions/NotificationManager";
import { UsersAutocompleteWrapper } from "pro-features/components/AutocompleteUsers/UsersAutocompleteWrapper";
import type { ISharingType } from "app/components/sharingAssetModal/components/sharingStateRadioOptions/types";

interface ISubsetOfUsers extends ISharingType {
    text: ISubsetOfUsersText;
    sharedWithUsers: Array<number>;
    setSharedWithUsers: (users: Array<number>) => void;
    notification: INotification;
    setNotification: (notification: INotification) => void;
    hideNotificationCheckbox?: boolean;
}

const Container = styled.div<{ isVisible }>`
    flex-direction: column;
    gap: 16px;
    width: 462px;
    padding-left: 38px;
    display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
`;

const AutocompleteContainer = styled.div`
    z-index: 1;
`;

export const SubsetOfUsers: FC<ISubsetOfUsers> = (props) => {
    const {
        sharingState,
        setSharingState,
        text,
        sharedWithUsers,
        setSharedWithUsers,
        notification,
        setNotification,
        isDisabled,
        hideNotificationCheckbox,
    } = props;
    const { title, subtitle } = text;
    const isSelected = sharingState === ESharingState.SUBSET_OF_USERS;
    const onUserSelect = (user) => {
        setSharedWithUsers([...sharedWithUsers, user.Id]);
    };
    const onRemoveUser = ({ Id }) => {
        const updatedSharedWithUsers = sharedWithUsers.filter((userID) => userID !== Id);
        setSharedWithUsers(updatedSharedWithUsers);
    };
    return (
        <>
            <SharingOption
                onClick={() => setSharingState(ESharingState.SUBSET_OF_USERS)}
                isSelected={isSelected}
                iconName={"users"}
                title={title}
                subTitle={subtitle}
                isDisabled={isDisabled}
            />
            <Container isVisible={isSelected}>
                <AutocompleteContainer>
                    <UsersAutocompleteWrapper
                        onUserSelect={onUserSelect}
                        onRemoveUser={onRemoveUser}
                        selectedUsersIDs={sharedWithUsers}
                    />
                </AutocompleteContainer>
                {!hideNotificationCheckbox ? (
                    <NotificationManager
                        notification={notification}
                        setNotification={setNotification}
                    />
                ) : null}
            </Container>
        </>
    );
};
